import { type MaybeRefOrGetter } from 'vue'
import { PrefixTranslationsEnum } from '@/common/types/i18n'
import { type CaseActionParamsDTOV1 } from '@/common/types/case'
import { type ListScreensParamsV1 } from '@/common/types/screen'
import { type UserParamsDTOV3 } from '@/common/types/users'

export const API_CACHE_KEYS = {
  LOCALES: 'locales',
  SPACES: 'spaces',
} as const

export const SERVER_DATA_SCOPE = {
  CASE_ACTIONS: 'CASE_ACTIONS',
  CHANNELS: 'CHANNELS',
  CUSTOM_FIELDS: 'CUSTOM_FIELDS',
  EMERGENCIES: 'EMERGENCIES',
  FILE_DEFINITION: 'FILE_DEFINITION',
  I18n: 'I18n',
  INTERACTION_CUSTOM: 'INTERACTION_CUSTOM',
  INTERACTION_TYPES: 'INTERACTION_TYPES',
  MAILBOXES: 'MAILBOXES',
  PRIORITIES: 'PRIORITIES',
  /** @deprecated */
  SCREENS_V1: 'SCREENS_V1',
  SCREENS_V3: 'SCREENS_V3',
  SKILLS: 'SKILLS',
  TEAMS: 'TEAMS',
  TYPOLOGIES: 'TYPOLOGIES',
  USERS: 'USERS',
} as const

export const SERVER_DATA_LABELS = {
  CASE_ACTIONS: [PrefixTranslationsEnum.TICKETACTIONTYPE],
  CHANNELS: [PrefixTranslationsEnum.INTERACTION_CHANNEL],
  CUSTOM_FIELDS: [PrefixTranslationsEnum.CUSTOMFIELD, PrefixTranslationsEnum.CFOPTION],
  EMERGENCIES: [PrefixTranslationsEnum.EMERGENCY],
  INTERACTION_CUSTOM: [PrefixTranslationsEnum.INTERACTION],
  INTERACTION_TYPES: [PrefixTranslationsEnum.INTERACTION_TYPE, PrefixTranslationsEnum.INTERACTION_CHANNEL],
  MAILBOXES: [PrefixTranslationsEnum.SPACE],
  PRIORITIES: [PrefixTranslationsEnum.PRIORITY],
  /** @deprecated */
  SCREENS_V1: [PrefixTranslationsEnum.SCREEN],
  SCREENS_V3: [PrefixTranslationsEnum.SCREEN],
  SKILLS: [PrefixTranslationsEnum.SPACE, PrefixTranslationsEnum.SKILL],
  TEAMS: [PrefixTranslationsEnum.USERGROUP],
  TYPOLOGIES: [PrefixTranslationsEnum.SPACE, PrefixTranslationsEnum.TYPOLOGY],
}

export type ServerDataScope = (typeof SERVER_DATA_SCOPE)[keyof typeof SERVER_DATA_SCOPE]
export type ServerDataScopeLabels = keyof typeof SERVER_DATA_LABELS
export type ServerDataScopeParams = {
  CASE_ACTIONS: CaseActionParamsDTOV1
  CUSTOM_FIELDS: MaybeRefOrGetter<string>
  I18n: PrefixTranslationsEnum
  /** @deprecated */
  SCREENS_V1: ListScreensParamsV1
  USERS: UserParamsDTOV3
}

export interface FetchOptionBase {
  //  The time in milliseconds after which data is considered stale. Set 0 to refetch.
  staleTime?: number
}
